import { UseLoadingReturn } from "@/hooks/use-loading";
import permissionService from "@/services/permissions.service";
import { RemoveByIdProps } from "@/types/requests.types";

import useRemove from "../../use-remove";

export type RemoveUserProfileProps = RemoveByIdProps;

export type UseRemoveUserProfileReturn = {
  remove: (props: RemoveUserProfileProps) => Promise<void>;
} & UseLoadingReturn;

const useRemoveUserProfile = (): UseRemoveUserProfileReturn => {
  const { isLoading, startLoading, endLoading, loadingIcon, remove } = useRemove({
    operation: (userId, profileId = 0) => permissionService.removeUserProfile(userId, profileId),
  });

  return {
    isLoading,
    startLoading,
    endLoading,
    loadingIcon,
    remove,
  };
};

export default useRemoveUserProfile;
